import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {Dialog, DialogContent, DialogContentText, Button} from '@material-ui/core';

import Conf from 'utils/Conf';
import BlastreamTopBar from 'components/BlastreamTopBar';
import SuspenseSpinner from 'components/SuspenseSpinner';

import './BlastreamRoom.scss';

const BlastreamRoom = ({params}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const route = params.userType === 'intervenant' ? 'event_intervenant' : 'event_multiplex_access';
    axios
      .get(`${Conf.apiBaseUri}/${route}/hash/${params.hash}`)
      .then(res => {
        setLoading(false);
        setData(res.data);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [params.hash, params.userType]);

  if (loading) return <SuspenseSpinner />;

  if (!data) {
    return (
      <div className="multiplex-container">
        <Dialog open className="my-dialog">
          <DialogContent>
            {/* <DialogContentText>{accessDeniedMsg}</DialogContentText> */}
            <DialogContentText>No access</DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  const currentLanguage = `lang=${localStorage.getItem('roomLang') || 'fr-FR'}`;
  const roomUrl = `${params.permission === 'live' ? data.live_url : data.management_url}&${currentLanguage}`;
  return (
    <>
      {data.live_url && <BlastreamTopBar />}
      <iframe
        id="blastream-room"
        title="Blastream room"
        allow="camera;microphone"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          zIindex: 999999,
        }}
        src={roomUrl}
      />
    </>
  );
};

export default BlastreamRoom;
